<template>
    <div class="levelBox">
        <div class="title">赛事级别</div>
        <div id="level" class="fl" :style="`width: 100%; height: 370px;`"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
    props: {
        raceChartList: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    data() {
        return {
            option: {
                backgroundColor: '#292941',
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                grid: {
                    top: '15%',
                    right: '3%',
                    bottom: '12%'
                },
                xAxis: [{
                    name: '级别',
                    type: 'category',
                    data: [],
                    axisLabel: {
                        margin: 10,
                        color: '#e2e9ff',
                        textStyle: {
                            fontSize: 12,
                            color: '#8585CF'
                        },
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#3D3D65',
                            type: 'solid'
                        }
                    },
                    axisTick: {
                        inside: true,
                    }
                }],
                yAxis: [{
                    minInterval: 1,
                    axisLabel: {
                        show: true,
                        color: '#e2e9ff',
                        textStyle: {
                            fontSize: 12,
                            color: '#8585CF'
                        },
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#3D3D65',
                            type: 'solid'
                        }
                    },
                    axisTick: {
                        inside: true,
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dashed',
                            color: 'rgba(61, 61, 101, 0.9)'
                        }
                    }
                }],
                series: [{
                    type: 'bar',
                    data: [],
                    barWidth: '20px',
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: '#5455FF' // 0% 处的颜色
                            }, {
                                offset: 1,
                                color: 'rgba(84, 132, 255, 0)' // 100% 处的颜色
                            }], false),
                            barBorderRadius: [10, 10, 0, 0],
                        }
                    }
                }]
            }
        }
    },
    methods: {
        set(data){
            data.map(v => {
                this.option.xAxis[0].data.push(v.name)
                this.option.series[0].data.push(v.count)
            })
            this.myChart = echarts.init(document.getElementById('level'));
            this.myChart.clear();//如果图表有修改需求建议加上此方法先清后画
            this.myChart.setOption(this.option);
        },
    }
}
</script>

<style lang="scss" scoped>
.levelBox{
    width: 30%;
    border-radius: 12px;
    overflow: hidden;
    #level{
        border-radius: 12px;
        overflow: hidden;
    }
    .title{
        margin-top: 24px;
        color: #fff;
        font-size: 16px;
        line-height: 22px;
        margin-bottom: 16px;
    }
}
#level{
    width: 600px;
    height: 370px;
    background-color: #292941;
}
</style>
